// pusher app id key etc are loaded in the config.json
export const PUSHER = {
  ENCRYPTED: true,
  AUTH: "/pusher/auth",
  EVENTS: {
    UPDATE: "update",
    NOTIFICATION: "notification"
  }
};
